import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { getErrorMessage } from "@/lib/api";
import AuthShell from "./AuthShell";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      nav("/");
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Connexion" subtitle="Accédez à votre espace documentaire.">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <Field label="Adresse e-mail">
          <input
            data-testid="login-email"
            type="email"
            required
            maxLength={200}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-white border border-zinc-300 px-4 py-2.5 text-sm focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] outline-none"
            autoComplete="email"
          />
        </Field>
        <Field label="Mot de passe">
          <input
            data-testid="login-password"
            type="password"
            required
            maxLength={128}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-white border border-zinc-300 px-4 py-2.5 text-sm focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] outline-none"
            autoComplete="current-password"
          />
        </Field>
        <button
          data-testid="login-submit"
          disabled={loading}
          className="w-full bg-[#002FA7] hover:bg-[#00227A] text-white text-sm font-medium py-3 transition-colors disabled:opacity-50"
        >
          {loading ? "Connexion..." : "Se connecter"}
        </button>
        <div className="flex items-center justify-between text-xs pt-2">
          <Link to="/forgot-password" className="text-zinc-600 hover:text-[#002FA7]" data-testid="forgot-link">
            Mot de passe oublié ?
          </Link>
          <Link to="/register" className="text-zinc-600 hover:text-[#002FA7]" data-testid="register-link">
            Créer un compte →
          </Link>
        </div>
      </form>
    </AuthShell>
  );
}

function Field({ label, children }) {
  return (
    <label className="block">
      <span className="block text-[11px] uppercase tracking-[0.15em] text-zinc-500 font-mono mb-2">
        {label}
      </span>
      {children}
    </label>
  );
}
